import { useMutation, useQueryClient } from '@tanstack/react-query'
import { usePagedList } from '@/lib/use-paged-list'
import { emailApi } from './email.service'
import type { ListEmailsParams, SendEmailInput } from './email.types'

const MESSAGES_KEY = 'email-messages'

// Paginated audit log of sent emails (branch-scoped).
export function useEmailMessages(
  filters: ListEmailsParams,
  pagination: { pageIndex: number; pageSize: number },
) {
  return usePagedList([MESSAGES_KEY, filters], pagination, ({ limit, offset }) =>
    emailApi.listMessages({ ...filters, limit, offset }),
  )
}

export function useSendEmail() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: SendEmailInput) => emailApi.send(data),
    onSettled: () => queryClient.invalidateQueries({ queryKey: [MESSAGES_KEY] }),
  })
}
